var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgElderlysIcon = function SvgElderlysIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81.302,
    height: 49.402,
    viewBox: "0 0 81.302 49.402",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1631",
    "data-name": "Ret\\xE2ngulo 1631",
    width: 37.708,
    height: 49.402,
    fill: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1632",
    "data-name": "Ret\\xE2ngulo 1632",
    width: 39.177,
    height: 46.347,
    fill: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1637",
    "data-name": "Ret\\xE2ngulo 1637",
    width: 3.987,
    height: 9.797,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1637-2",
    "data-name": "Ret\\xE2ngulo 1637",
    width: 3.986,
    height: 9.797,
    fill: "#4b4b4b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5865",
    "data-name": "Grupo 5865",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5855",
    "data-name": "Grupo 5855",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4476",
    "data-name": "Caminho 4476",
    d: "M4.539,38.42A18.381,18.381,0,0,0,8,44.512,14.257,14.257,0,0,0,18.855,49.4a14.262,14.262,0,0,0,10.855-4.89,18.427,18.427,0,0,0,3.461-6.093c1.174-.11,3.381-.954,4.3-5.533.466-2.334.255-4.067-.631-5.146a2.993,2.993,0,0,0-2.02-1.082c0-.581-.01-1.149-.032-1.708,2.443-8.544-1.522-14.88-6.992-17.871A9.81,9.81,0,0,0,18.537,0,9.943,9.943,0,0,0,8.874,9.025c-7.308,3.55-7.261,12.32-6.437,17.717a2.946,2.946,0,0,0-1.566,1c-.884,1.08-1.1,2.812-.629,5.147.916,4.581,3.126,5.424,4.3,5.533M2.292,28.905a1.134,1.134,0,0,1,.469-.339c.083.4.165.766.243,1.087.006.078.008.152.013.231a31.113,31.113,0,0,0,.875,6.378c-.632-.44-1.391-1.446-1.848-3.736-.344-1.718-.256-3.005.249-3.621m33.123,0c.505.615.594,1.9.25,3.621-.457,2.287-1.215,3.293-1.845,3.734a30.906,30.906,0,0,0,.869-6.337c.036-.477.062-.949.083-1.414a1.159,1.159,0,0,1,.643.4m-4.567,9.5c-2.5,6.342-7.405,8.795-11.993,8.795S9.363,44.748,6.866,38.4c-.118-.3-.23-.6-.335-.919-.1-.3-.2-.6-.288-.919a28.493,28.493,0,0,1-1.024-6.805c-.032-.433-.057-.858-.077-1.28-.015-.31-.023-.614-.03-.919s-.015-.616-.015-.919c0-.392,0-.779.011-1.16A43.812,43.812,0,0,1,11,13.965c1.13,5.462,7.181,8.7,12.814,10.566h-.83a.459.459,0,0,0,0,.919h3.959c2.314.6,4.348.965,5.663,1.168v.024c0,.3-.006.61-.015.919s-.015.609-.029.919c-.02.434-.046.873-.08,1.32a28.3,28.3,0,0,1-1.017,6.766c-.091.314-.186.62-.286.919q-.159.473-.335.919",
    transform: "translate(0 0)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4477",
    "data-name": "Caminho 4477",
    d: "M17.57,40.683c.021-1.127-.365-1.816-1.1-2.025a2.3,2.3,0,0,0-1.154,0c-.735.208-1.122.9-1.1,2.025-.027,1.394.562,2.131,1.679,2.1,1.115.035,1.705-.7,1.678-2.1",
    transform: "translate(-3.749 -10.179)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4478",
    "data-name": "Caminho 4478",
    d: "M34.7,38.658a2.3,2.3,0,0,0-1.154,0c-.735.208-1.122.9-1.1,2.025-.027,1.394.562,2.131,1.677,2.1,1.115.035,1.707-.7,1.678-2.1.023-1.127-.365-1.816-1.1-2.025",
    transform: "translate(-8.559 -10.179)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4479",
    "data-name": "Caminho 4479",
    d: "M23.659,51.363l.222.112a2.785,2.785,0,0,0,2.223,0l.223-.112c.4-.2.483-.381.28-.479a1.3,1.3,0,0,0-.542-.084H23.92a1.3,1.3,0,0,0-.541.084c-.2.1-.122.276.28.479",
    transform: "translate(-6.139 -13.402)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4480",
    "data-name": "Caminho 4480",
    d: "M28.234,53.788c-.053.066-1.333,1.6-4.637,1.6s-4.581-1.528-4.639-1.6a.551.551,0,0,0-.865.682c.063.083,1.625,2.02,5.5,2.02s5.438-1.937,5.5-2.02a.548.548,0,0,0-.092-.768.554.554,0,0,0-.774.085",
    transform: "translate(-4.742 -14.135)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4481",
    "data-name": "Caminho 4481",
    d: "M18.642,33.78a.457.457,0,0,0-.459-.459H13.59a.459.459,0,0,0,0,.919h4.594a.458.458,0,0,0,.459-.46",
    transform: "translate(-3.464 -8.79)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4482",
    "data-name": "Caminho 4482",
    d: "M16.405,50.5a.225.225,0,0,0-.056-.447,2.826,2.826,0,0,0-1.868,1.5,2.824,2.824,0,0,0-.457,2.348.225.225,0,0,0,.421-.158,2.416,2.416,0,0,1,.421-1.958A2.416,2.416,0,0,1,16.405,50.5",
    transform: "translate(-3.677 -13.203)",
    fill: "#4b4b4b",
    stroke: "#4b4b4b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4483",
    "data-name": "Caminho 4483",
    d: "M33.136,50.5a.225.225,0,0,1,.056-.447,3.474,3.474,0,0,1,2.325,3.844.225.225,0,0,1-.421-.158,3.07,3.07,0,0,0-1.96-3.24",
    transform: "translate(-8.689 -13.203)",
    fill: "#4b4b4b",
    stroke: "#4b4b4b",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5857",
    "data-name": "Grupo 5857",
    transform: "translate(42.125 2.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_6",
    "data-name": "Subtra\\xE7\\xE3o 6",
    d: "M19.588,46.346a11.818,11.818,0,0,1-4.766-.822A12.685,12.685,0,0,1,8.8,41.993a18.564,18.564,0,0,1-4.289-8.351C3.3,33.517,1.141,32.63.24,28.109c-.467-2.333-.254-4.063.629-5.145A3.028,3.028,0,0,1,3,21.873,21.914,21.914,0,0,1,4.182,10.721a17.535,17.535,0,0,1,6.736-8.415A16.36,16.36,0,0,1,19.678,0a16.356,16.356,0,0,1,8.756,2.306,17.577,17.577,0,0,1,6.74,8.415A21.945,21.945,0,0,1,36.352,21.89a3.017,3.017,0,0,1,1.955,1.075c.887,1.081,1.1,2.812.627,5.145-.9,4.515-3.055,5.4-4.26,5.533a18.526,18.526,0,0,1-4.289,8.351,12.7,12.7,0,0,1-6.029,3.53A11.842,11.842,0,0,1,19.588,46.346ZM5.566,24.752h0v.012c0,.113.008.229.018.344a40.47,40.47,0,0,0,.758,6.682c.066.331.135.642.2.923.076.308.158.617.242.919a15.6,15.6,0,0,0,3.861,7.078,15.323,15.323,0,0,0,2.307,1.671,12.453,12.453,0,0,0,5.5,1.848c.283.017.568.024.852.024a14.289,14.289,0,0,0,5.514-1.073,10.907,10.907,0,0,0,3.707-2.452,15.57,15.57,0,0,0,3.869-7.1c.086-.3.166-.611.242-.919.063-.258.125-.543.205-.923a40.464,40.464,0,0,0,.748-6.644l0-.024c0-.072.008-.142.01-.211a.5.5,0,0,0,0-.054.95.95,0,0,1,.006-.1l-1.084.063v0c-.012.3-.141,3-1.168,4.239-.68.817-2.926,1.108-4.8,1.108a11.248,11.248,0,0,1-2.955-.312,3.559,3.559,0,0,1-2.514-3.374h-3a3.557,3.557,0,0,1-2.512,3.374,11.254,11.254,0,0,1-2.957.313c-1.875,0-4.121-.291-4.8-1.108C6.738,27.75,6.65,24.843,6.65,24.814l-1.084-.062ZM36.084,23.71h0C36,24.2,35.9,24.7,35.8,25.184a.391.391,0,0,0-.006.081,44.337,44.337,0,0,1-.668,6.329c1.158-.666,1.732-2.456,2.012-3.841.342-1.719.254-3.006-.25-3.624A1.174,1.174,0,0,0,36.084,23.71ZM3.244,23.7a1.215,1.215,0,0,0-.951.427c-.506.619-.594,1.906-.248,3.624.273,1.388.848,3.18,2.014,3.841a43.215,43.215,0,0,1-.674-6.367c-.029-.379-.053-.784-.072-1.275l0-.03L3.3,23.86c-.008-.055-.02-.107-.029-.157Zm24.713-.389a15.822,15.822,0,0,0-3.529.393c-.762.188-1.709.518-1.889,1.024a3.682,3.682,0,0,0,1.08,3.95,6.163,6.163,0,0,0,2.736.425c1.543,0,3.334-.243,3.855-.789a3.63,3.63,0,0,0,.729-2.226,5.075,5.075,0,0,0-.283-2.229.606.606,0,0,0-.186-.156A5.65,5.65,0,0,0,27.957,23.313Zm-16.738,0a5.66,5.66,0,0,0-2.516.393.612.612,0,0,0-.182.156,5.026,5.026,0,0,0-.287,2.229,3.655,3.655,0,0,0,.73,2.226c.523.546,2.313.789,3.855.789a6.168,6.168,0,0,0,2.738-.425,3.685,3.685,0,0,0,1.078-3.95c-.18-.508-1.125-.837-1.887-1.024A15.84,15.84,0,0,0,11.219,23.313Zm-1.127-1.187a19.53,19.53,0,0,1,5.834.66,3.9,3.9,0,0,1,1.563.919,1.968,1.968,0,0,1,.539,1.063h3.119a1.948,1.948,0,0,1,.539-1.062,3.9,3.9,0,0,1,1.564-.919,19.549,19.549,0,0,1,5.836-.66,19.841,19.841,0,0,1,4.613.627,20.524,20.524,0,0,0-.051-7.661,17.642,17.642,0,0,0-3.465-7.836,12.464,12.464,0,0,0-4.279-3.4,14.2,14.2,0,0,0-6.2-1.32H19.7A13.2,13.2,0,0,0,9.428,7.092c-3.318,3.82-4.795,9.676-3.951,15.662a.109.109,0,0,0,0,.022v.016h0V22.8l0-.008h0a.1.1,0,0,0,0-.038A19.614,19.614,0,0,1,10.092,22.127Z",
    transform: "translate(0 0)",
    fill: "#4b4b4b",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4490",
    "data-name": "Caminho 4490",
    d: "M16.891,36.609c1.116.029,1.7-.62,1.678-1.849.026-1.228-.562-1.878-1.678-1.847-1.116-.031-1.705.618-1.678,1.847-.027,1.229.562,1.879,1.678,1.849",
    transform: "translate(-4.013 -8.682)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4491",
    "data-name": "Caminho 4491",
    d: "M35.123,32.912c-1.118-.031-1.707.618-1.679,1.848-.027,1.229.562,1.879,1.679,1.849,1.115.03,1.7-.62,1.678-1.849.026-1.228-.563-1.879-1.678-1.848",
    transform: "translate(-8.822 -8.681)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4492",
    "data-name": "Caminho 4492",
    d: "M24.655,45.207l.222.112a1.9,1.9,0,0,0,.208.087,2.905,2.905,0,0,0,1.807,0,1.664,1.664,0,0,0,.207-.087l.223-.112c.613-.308.495-.561-.26-.561H24.916c-.756,0-.872.253-.261.561",
    transform: "translate(-6.401 -11.777)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4493",
    "data-name": "Caminho 4493",
    d: "M19.957,48.3a.552.552,0,0,0-.866.684c.063.081,1.623,2.019,5.5,2.019s5.44-1.938,5.5-2.019a.551.551,0,0,0-.864-.684c-.054.066-1.335,1.6-4.639,1.6s-4.58-1.528-4.637-1.6",
    transform: "translate(-5.005 -12.686)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4494",
    "data-name": "Caminho 4494",
    d: "M17.559,45.458a.225.225,0,0,0-.056-.447,2.826,2.826,0,0,0-1.868,1.5,2.824,2.824,0,0,0-.457,2.348A.225.225,0,0,0,15.6,48.7a2.416,2.416,0,0,1,.421-1.958,2.416,2.416,0,0,1,1.539-1.282",
    transform: "translate(-3.981 -11.873)",
    fill: "#4b4b4b",
    stroke: "#4b4b4b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4495",
    "data-name": "Caminho 4495",
    d: "M34.29,45.458a.225.225,0,0,1,.056-.447,3.476,3.476,0,0,1,2.325,3.844.224.224,0,0,1-.289.13.226.226,0,0,1-.133-.288,3.069,3.069,0,0,0-1.959-3.24",
    transform: "translate(-8.994 -11.873)",
    fill: "#4b4b4b",
    stroke: "#4b4b4b",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4496",
    "data-name": "Caminho 4496",
    d: "M19.15,27.623H14.556a.551.551,0,0,0,0,1.1H19.15a.551.551,0,0,0,0-1.1",
    transform: "translate(-3.694 -7.287)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4497",
    "data-name": "Caminho 4497",
    d: "M32.026,28.726H36.62a.551.551,0,1,0,0-1.1H32.026a.551.551,0,0,0,0,1.1",
    transform: "translate(-8.303 -7.287)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5871",
    "data-name": "Grupo 5871",
    transform: "translate(4.768 14.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5870",
    "data-name": "Grupo 5870",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4499",
    "data-name": "Caminho 4499",
    d: "M3.235,3.78A9.4,9.4,0,0,1,.339,0C.263,3.267.157,6.533,0,9.8A37.058,37.058,0,0,0,3.987,4.951L2.381,4.318Z",
    transform: "translate(0 0)",
    fill: "#4b4b4b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5872",
    "data-name": "Grupo 5872",
    transform: "translate(30.426 14.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5870-2",
    "data-name": "Grupo 5870",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4499-2",
    "data-name": "Caminho 4499",
    d: "M.752,3.779A9.4,9.4,0,0,0,3.647,0c.076,3.267.182,6.533.339,9.8A37.057,37.057,0,0,1,0,4.951l1.606-.633Z",
    transform: "translate(0 0)",
    fill: "#4b4b4b"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgElderlysIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/elderlys_icon.0e12d2b9.svg";
export { ForwardRef as ReactComponent };